module.exports = __webpack_public_path__ + "static/media/platform-step4-desktop.693a9409.png";